import { days_formatter, tutor_Invoice_status_formatter, group_status_formatter, assessment_status_formatter, work_type_formatter, student_Invoice_status_formatter } from "../utils/formatters";
import Vue from 'vue'
Vue.mixin({
    methods: {
        days_formatter,
        group_status_formatter,
        assessment_status_formatter,
        work_type_formatter,
        student_Invoice_status_formatter,
        tutor_Invoice_status_formatter
    },
    data() {
        return {
            navigation: true
        };
    },
})